import { useCallback } from 'react';
import styled from '@emotion/styled';
import { FunctionComponent } from 'react';
import { useResizedImage } from '../../hooks';
import placeholder from '../../assets/image-placeholder-h52.jpg';
import _ from 'lodash';
import { useModalProvider } from '../ModalProvider';
import PreviewImageModal, { PreviewImageModalProps } from './PreviewImageModal';

export interface ThumbnailProps {
  cityId: string;
  thumb: string;
}

const ThumbImage = styled.img({
  maxHeight: '52px',
  height: 'auto',
  width: 'auto',
  padding: '0',
  margin: '0',
  aspectRatio: '16 / 9',
  objectFit: 'contain',
  cursor: 'pointer',
});

const Thumbnail: FunctionComponent<ThumbnailProps> = ({ thumb, cityId }) => {
  const uri = useResizedImage(cityId, thumb);
  const { openModal, closeModal } = useModalProvider();

  const handleClosePreview = useCallback(() => {
    closeModal({
      identifier: 'PreviewImageModal',
    });
  }, [closeModal]);

  const handleOpenPreview = useCallback(() => {
    openModal<PreviewImageModalProps>({
      identifier: 'PreviewImageModal',
      component: PreviewImageModal,
      additionalProps: {
        imageId: thumb,
        cityId: cityId,
        onClose: handleClosePreview,
      },
    });
  }, [openModal, handleClosePreview, cityId, thumb]);

  return (
    <ThumbImage
      alt="Contenuto campagna"
      src={_.isNil(uri) ? placeholder : uri}
      title="Contenuto campagna"
      onClick={handleOpenPreview}
    />
  );
};

export default Thumbnail;
